import React from 'react';
import constant from '../constants/Constatnt';
import MobileStepper from '@mui/material/MobileStepper';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { makeStyles } from "@mui/styles"
import { useTheme, styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { IconButton } from "@mui/material";
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import { appTheme } from '../theme/colorTheme';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const useStyles = makeStyles(() => ({
    root: {
        "& .MuiMobileStepper-dot": { backgroundColor: appTheme.color9 },
        "& .MuiMobileStepper-dotActive": { backgroundColor: appTheme.color12 }
    }
}));

const StyledIconButton = styled(IconButton)`
height: 35px;
width: 35px;
position: absolute;
border-radius: 100%;
right:${(props) => (props?.isleft === "true" ? "none" : "0")};;
left:${(props) => (props?.isleft === "true" ? "0" : "none")};
top:35%;
background-color: rgba(0, 0, 0, 0.5);
color: white;
border-color: rgba(0, 0, 0, 0.3);
z-index: 1;
opacity: 1;
:hover {
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px rgba(0, 0, 0, 0.5), 0px 1px 10px rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.5);
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
}
`;


const CarouselSliderList = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = props.data.length;

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      };
    
      const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
      };
    
    const handleStepChange = (step) => {
        setActiveStep(step);
    };
    const Slider = () => {
        return (
            <Box sx={{ flexGrow: 1, mt:1, position:'relative' }}>

                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <AutoPlaySwipeableViews
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={activeStep}
                        onChangeIndex={handleStepChange}
                        enableMouseEvents
                    >
                        {props.data.map((step, index) => (
                            <div key={index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor:'pointer', 
                            }} 
                            onClick={() => {
                                if(!!props.navigate) props.navigate(props.navigationEndpoint)
                            }} 
                            >
                                {Math.abs(activeStep - index) <= 2 ? (
                                    <Box
                                    component="img"
                                        style={{
                                            display: 'block',
                                            overflow: 'hidden',
                                        }}
                                        src={!!step.isStatic?step.image_url:`${constant.baseUrl}/${step.image_url}`}
                                        alt="slider"
                                    />
                                ) : null}
                            </div>
                        ))}
                    </AutoPlaySwipeableViews>
                    { props.data.length !==1 && <>
                        <StyledIconButton isleft="false" onClick={activeStep === maxSteps - 1?'':handleNext}>
                        <ArrowForwardIosRoundedIcon />
                    </StyledIconButton>
                    <StyledIconButton isleft="true" onClick={activeStep === 0?'':handleBack}>
                        <ArrowBackIosNewRoundedIcon />
                    </StyledIconButton>
                    </>}
                </Box>
                <Box>
              
                           
                            
                    <MobileStepper
                        variant="dots"
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'transparent' }}
                        steps={maxSteps}
                        position="static"
                        activeStep={activeStep}
                        classes={classes}
                    />
                </Box>



            </Box>
        )
    }

    return (
        <Slider />
    )
}
const CarouselSlider = React.memo(CarouselSliderList);
export default CarouselSlider;